/**
 * Validate required environment variables for Keycloak SSO
 */
export function validateKeycloakEnv(): void {
  const required = [
    'VITE_KEYCLOAK_BASE_URL',
    'VITE_KEYCLOAK_REALM',
    'VITE_KEYCLOAK_CLIENT_ID',
  ];

  const missing: string[] = [];

  required.forEach((key) => {
    const value = import.meta.env[key];
    if (!value || value.trim() === '') {
      missing.push(key);
    }
  });

  if (missing.length > 0) {
    console.error('Missing required Keycloak environment variables:', missing);
    throw new Error(
      `Missing required Keycloak environment variables: ${missing.join(', ')}. ` +
      'Please check your .env file and ensure all Keycloak configuration is set.'
    );
  }
}

/**
 * Get Keycloak configuration from environment variables
 */
export function getKeycloakConfig() {
  validateKeycloakEnv();

  return {
    url: import.meta.env.VITE_KEYCLOAK_BASE_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  };
}
